<script lang="ts">
    import { scale } from 'svelte/transition';
    import { patternsInfo } from '../../../fixtures';

    interface Params {
        patterns: Record<string, boolean>;
        type: 'candlestick' | 'chart';
    }

    let { patterns = $bindable(), type }: Params = $props();

    let tooltips: Record<string, boolean> = $state({});
    let tooltipPos: Record<string, { x: number; y: number }> = $state({});
    const filtered = patternsInfo.filter(p => p.type === type);

    function showTooltip(e: MouseEvent, slogan: string) {
        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
        tooltipPos[slogan] = {
            x: rect.right + 8,
            y: rect.top,
        };
        tooltips[slogan] = true;
    }
</script>

<ul class="list-unstyled mb-0">
    {#each filtered as pattern}
        <div class="form-check form-switch">
            <input
                class="form-check-input"
                type="checkbox"
                id={`pattern_${pattern.slogan}`}
                role="switch"
                bind:checked={patterns[pattern.slogan]}
            />
            <label
                class="form-check-label"
                for={`pattern_${pattern.slogan}`}
                style="cursor: help"
                onmouseenter={(e) => showTooltip(e, pattern.slogan)}
                onmouseleave={() => tooltips[pattern.slogan] = false}
            >
                {pattern.name}
            </label>
            {#if tooltips[pattern.slogan] && tooltipPos[pattern.slogan]}
                <div
                    class="pattern-tooltip"
                    style="left:{tooltipPos[pattern.slogan].x}px; top:{tooltipPos[pattern.slogan].y}px"
                    transition:scale={{ duration: 120 }}
                >
                    {@html pattern.description}
                </div>
            {/if}
        </div>
    {/each}
</ul>

<style>
    .pattern-tooltip {
        position: fixed;
        z-index: 9999;
        min-width: 240px;
        max-width: 320px;
        background: #fff;
        border: 1px solid #d0d0d0;
        border-radius: 6px;
        padding: 8px 10px;
        font-size: 0.75rem;
        line-height: 1.45;
        color: #333;
        box-shadow: 0 4px 16px rgba(0,0,0,0.14);
        pointer-events: none;
    }
</style>
